import { render } from "./XIconSolidAddressBook.vue?vue&type=template&id=9c78296a"
import script from "./XIconSolidAddressBook.vue?vue&type=script&lang=js"
export * from "./XIconSolidAddressBook.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidAddressBook.vue"]])

export default __exports__